import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMemo } from 'react';
import { PackingApiAdapter } from '../adapters';
import { PackingService } from '../services';

/**
 * Hook que provee una instancia configurada del PackingService
 */
export const usePackingService = () => {
    return useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        const adapter = new PackingApiAdapter(httpClient);
        return new PackingService(adapter);
    }, []);
}; 